export const BASE_URL = process.env.REACT_APP_BASE_URL || '';
export const API_URL = process.env.REACT_APP_API_URL || '';
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || '';
export const CUSTOMER_PORTAL_URL = process.env.REACT_APP_CUSTOMER_PORTAL_URL || '';
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || '';
export const HOME_URL = process.env.REACT_APP_HOME_URL || '';
export const DEFAULT_ADDRESS_CHARACTER_LIMIT = 30;
export const COURIERS_PLEASE_ADDRESS_CHARACTER_LIMIT = 19;
export const STAR_TRACK_FIRST_NAME_CHARACTER_LIMIT = 15;
export const STAR_TRACK_LAST_NAME_CHARACTER_LIMIT = 15;
export const STAR_TRACK_COMAPNY_NAME_CHARACTER_LIMIT = 19;
export const STAR_TRACK_ADDRESS_CHARACTER_LIMIT = 40;
export const TNT_ADDRESS_CHARACTER_LIMIT = 30;
export const TNT_PHONE_CHARACTER_LIMIT = 13;
export const TOLL_ADDRESS_CHARACTER_LIMIT = 40;
export const ALLIED_EXPRESS_ADDRESS_CHARACTER_LIMIT = 100;
export const COURIERS_PLEASE_COMAPNY_NAME_CHARACTER_LIMIT = 19;
export const COURIERS_PLEASE_FIRST_NAME_CHARACTER_LIMIT = 15;
export const COURIERS_PLEASE_LAST_NAME_CHARACTER_LIMIT = 15;
export const TOLL_FIRST_NAME_CHARACTER_LIMIT = 19;
export const TOLL_LAST_NAME_CHARACTER_LIMIT = 19;
export const TOLL_COMAPNY_NAME_CHARACTER_LIMIT = 40;
export const TOLL_PALLETISED_EXPRESS_FIRST_NAME_CHARACTER_LIMIT = 20;
export const TOLL_PALLETISED_EXPRESS_LAST_NAME_CHARACTER_LIMIT = 20;
export const TOLL_PALLETISED_EXPRESS_COMAPNY_NAME_CHARACTER_LIMIT = 40;
export const TOLL_PALLETISED_EXPRESS_ADDRESS_CHARACTER_LIMIT = 30;
export const TOLL_PALLETISED_EXPRESS_PHONE_CHARACTER_LIMIT = 10;
export const BONDS_COURIER_FIRST_NAME_CHARACTER_LIMIT = 10;
export const BONDS_COURIER_LAST_NAME_CHARACTER_LIMIT = 10;
export const BONDS_COURIER_COMAPNY_NAME_CHARACTER_LIMIT = 50;
export const BONDS_COURIER_ADDRESS_CHARACTER_LIMIT = 30;
export const BONDS_COURIER_PHONE_CHARACTER_LIMIT = 14;
export const CAPITAL_TRANSPORT_FIRST_NAME_CHARACTER_LIMIT = 15;
export const CAPITAL_TRANSPORT_LAST_NAME_CHARACTER_LIMIT = 15;
export const CAPITAL_TRANSPORT_COMPANY_NAME_CHARACTER_LIMIT = 20;
export const CAPITAL_TRANSPORT_ADDRESS_CHARACTER_LIMIT = 30;
export const WP_SITE_URL = process.env.REACT_APP_WP_SITE_URL || '';
export const WOOCOMMERCE_PLUGIN_URL = process.env.REACT_APP_WOOCOMMERCE_PLUGIN_URL || '';
export const ENTERPRISE_DOCS_URL = process.env.REACT_APP_ENTERPRISE_DOCS_URL || '';
export const GTM_ID = process.env.REACT_APP_GTM_ID || '';
export const MRL_GLOBAL_ADDRESS_CHARACTER_LIMIT = 40;
export const MRL_GLOBAL_PHONE_CHARACTER_LIMIT = 13;
export const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE || '';
export const PAYMENT_FLOW_V1_ENABLED = process.env.REACT_APP_PAYMENT_FLOW_V1_ENABLED === 'true';

// Brand colors (2026 branding refresh). Mirror of the SCSS tokens in
export const BRAND_COLORS = {
  primary: '#FF8E01',
  primaryHover: '#E67F00',
  textDark: '#333333',
  white: '#FFFFFF',
} as const;
